import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

// The floating panels of a development build. `VITE_DEVTOOLS=off` hides them:
// they sit over the corners of the shell, where the browser tests click.
const DEVTOOLS = import.meta.env.DEV && import.meta.env.VITE_DEVTOOLS !== "off";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});

function Root() {
  return (
    <>
      <Outlet />
      {DEVTOOLS && <TanStackRouterDevtools position="bottom-left" />}
    </>
  );
}
